/** @format */

export const REST_URLS = {
  LOGIN: "/v1/simpcare/auth/login",
  TICKETS: "/v1/simpcare/ticket",
  COMPLAINT: "/v1/simpcare/complaintForms",
  ASSIGN_TICKET_APPROVER: "/v1/simpcare/ticket/assign-approver",
  APPROVE_REJECT_ENGINE: "/v1/simpcare/ticket/approve-engine-replacement",
  LIST_OEMS: "/v1/simpcare/oems/list-oems",
  STAGE_VIEW: "/v1/simpcare/stage/view",
  ASSIGN_SE: "/v1/simpcare/stage/assign-se",
  CREATE_FOC: "/v1/simpcare/foc",
  DEFECT_ACTION: "/v1/simpcare/stage/update-defect-code",
  UPDATE_ACTION_CODE: "/v1/simpcare/stage/update-action-code",
  A002_ACTION: "/v1/simpcare/stage/engine-replacement",
  A003_ACTION: "/v1/simpcare/stage/part-replacement",
  CODES: "/v1/simpcare/codes?type=",
  GET_CODES: "/v1/simpcare/codes",
  SERVICE_ENGINEER: "/v1/simpcare/users",
  COMMENT: "/v1/simpcare/comment",
  OEM_COMMENT: "/v1/simpcare/comment/oem",
  ADD_SERVICE_ENGINEER: "/v1/simpcare/auth/register",
  TICKETS_REPORTS: "/v1/simpcare/reports/filterby-status",
  SE_REPORTS: "/v1/simpcare/reports/filterby-SE",
  List_CODES: "/v1/simpcare/codes",
  OEM_REPORTS: "/v1/simpcare/reports/filterby-OEM",
  LIST_REPORTS_OEMS: "/v1/simpcare/reports/list-oems",
  MAILING_LIST: "/v1/simpcare/mailing-list",
  DASHBOARD: "/v1/simpcare/dashboard/all-info",
  OEM_DASHBOARD: "/v1/simpcare/dashboard/oem/all-info",
  OEMS: "/v1/simpcare/oems",
  TICKETS_COUNTS: "/v1/simpcare/dashboard/ticket-counts",
  OEM_TICKETS_COUNTS: "/v1/simpcare/dashboard/oem/ticket-counts",
  OUT_OF_WARRANTY: "/v1/simpcare/stage/extended-warranty-help",
  ENTER_ENGINE_DETAILS: "/v1/simpcare/stage/enter-engine-details",
  OEM_NAMES: "/v1/simpcare/oems/names",
  REFRESH_TOKEN: "/v1/simpcare/auth/refresh-tokens",
  UPLOAD_FILES: "/v1/simpcare/misc/upload/attachment2/",
  UPLOAD_FILE: "/v1/simpcare/misc/upload/attachment/",
  HIGHLIGHTS: "/v1/simpcare/dashboard/highlights",
  CUR_YEAR_TREND: "/v1/simpcare/dashboard/cur-year-trend",
  OEM_LOGIN: "/v1/simpcare/oems/login",
  LIST_OEM_TICKETS: "/v1/simpcare/oems/list-tickets",
  LIST_COMPLAINT_CODES: "/v1/simpcare/oems/list-complaint-codes",
  SEARCH_TICKET_ID: "/v1/simpcare/stage/ticket-ids/search",
  SEARCH_USER: "/v1/simpcare/users/search-users",
  SEARCH_SERVICE_ENGINEER: "/v1/simpcare/stage/user/search",
  FORGOT_PASSWORD: "/v1/simpcare/auth/forgot-password",
  OEM_FORGOT_PASSWORD: "/v1/simpcare/oems/forgot-password",
  RESET_PASSWORD: "/v1/simpcare/auth/reset-password",
  GET_TRAININGS: "/v1/simpcare/oem/trainings",
  CREATE_COURSE: "/v1/simpcare/course-schedule",
  GET_COURSE_DATES_LIST: "/v1/simpcare/course-schedule",
  GET_TRAINING_DATES_LIST: "/v1/simpcare/course-schedule/oem",
  GET_DAY_TRAINING_LIST: "/v1/simpcare/training-schedule/day-schedule",
  CREATE_TRAINING_SCHEDULE: "/v1/simpcare/training-schedule",
  APPROVE_TRAINING_LIST: "/v1/simpcare/training-schedule/approval",
  UPDATE_PARTICIPANT_LIST: "/v1/simpcare/training-schedule",
  DOWNLOAD_TRAINING_REPORT:
    "/v1/simpcare/course-schedule/plan-vs-actual-report",
  OEM_APPROVAL_STATUS: "/v1/simpcare/training-schedule/oem",
  OEM_CERTIFICATE_DOWNLOAD:
    "/v1/simpcare/training-schedule/download-certificates",
  CREATE_REQUEST_COURSE: "/v1/simpcare/course-schedule/request-course",
  GET_REQUESTED_COURSE_LIST: "/v1/simpcare/course-schedule",
  ACCEPT_REQUESTED_COURSE:
    "/v1/simpcare/course-schedule/approve-requested-course",
  FLOAT_ENGINE: "/v1/simpcare/float-engine",
  APPROVER_LIST: "/v1/simpcare/users/approver-list",
  GET_ENGINE_DETAILS: "/v1/simpcare/engine-details",
  CREATE_WORK_ORDER: "/v1/simpcare/work-order",
  ADVANCE_ENGINE_REPLACEMENT: "/v1/simpcare/advanced-engine-replacement",
  GET_JIR_FROM_TICKET: "/v1/simpcare/joint-inspection-report",
  OEM_GET_JIR_FROM_TICKET: "/v1/simpcare/joint-inspection-report/oem",
  DOWNLOAD_TICKETS: "/v1/simpcare/ticket/download-tickets-info",
  OEM_DOWNLOAD_TICKETS: "/v1/simpcare/ticket/oem/download-tickets-info",
  SEARCH_ENGINE: "/v1/simpcare/ticket/search-engine",
  SEARCH_ENGINE_LIST: "/v1/simpcare/engine-details/search-engine",
  ADMIN_SEARCH_ENGINE_LIST: "/v1/simpcare/engine-details/search-engine-admin",
  LIST_ADMIN_OEMS: "/v1/simpcare/oems/user/list-oems",
  GET_TICKET_DETAILS_FROM_ENGINE: "/v1/simpcare/work-order/info",
  FOC: "/v1/simpcare/foc",
  WORKSHOP_MANUAL: "/v1/simpcare/workshop-manual",
  SERVICE_INFORMATION: "/v1/simpcare/service-information",
  SERVICE_BULLETINS: "/v1/simpcare//service-bulletin",
  INTERNAL_CUTIN: "/v1/simpcare/internal-cut-in",
  FAQ: "/v1/simpcare/faq",
  FAILED_ENGINE_ANALYSIS: "/v1/simpcare/failed-engine-analysis",
  FAILED_PART_ANALYSIS: "/v1/simpcare/failed-part-analysis",
  ICA_ANALYSIS: "/v1/simpcare/ica-capa",
  ENGINE_CUT_IN_NUMBER: "/v1/simpcare/engine-cut-in-number",
  USERS: "/v1/simpcare/users",
  LIMITS: "/v1/simpcare/limits",
  PRODUCTS: "/v1/simpcare/product",
  COOLANT_SYSTEM: "/v1/simpcare/coolant-system/",
  CLAIMS: "/v1/simpcare/claims",
  ENGINEER_MOVEMENT: "/v1/simpcare/engineer-movement",
  PERFORMER: "/v1/simpcare/performer",
  SAP_CLAIMS: "/v1/simpcare/claims/sap",
  INFANT_CARE: "/v1/simpcare/infant-care",
  BENCH_MARKING: "/v1/simpcare/bench-marking",
  STOCK_DETAILS: "/v1/simpcare/float-engine/sap",
  DASHBOARD_ENGINE_REPLACEMENT:
    "/v1/simpcare/dashboard/engine-replacement-trend",
  DASHBOARD_STATE_WISE_DATA: "/v1/simpcare/dashboard/state-wise",
  DASHBOARD_HMR_DATA: "/v1/simpcare/dashboard/hmr-wise",
  DASHBOARD_INVOICE_DATA:
    "/v1/simpcare/dashboard/engine-replacement-invoice-trend",
  OEM_DASHBOARD_INVOICE_DATA:
    "/v1/simpcare/dashboard/oem/engine-replacement-invoice-trend",
  DASHBOARD_OEM_MODEL_DATA: "/v1/simpcare/dashboard/oem-model-wise",
  DASHBOARD_PART_DATA: "/v1/simpcare/dashboard/part-wise",
  GET_MODEL_WISE_REPORT:
    "/v1/simpcare/dashboard/defect-code-model-wise-failure",
  GET_OEM_MODEL_WISE_REPORT:
    "/v1/simpcare/dashboard/oem/defect-code-model-wise-failure",

  GET_OEM_WISE_REPORT:
    "/v1/simpcare/dashboard/defect-code-oem-org-wise-failure",
  GET_OEM_WISE_REPORT_FOR_OEM:
    "/v1/simpcare/dashboard/oem/defect-code-oem-org-wise-failure",

  GET_HMR_WISE_REPORT: "/v1/simpcare/dashboard/defect-code-hmr-wise-failure",
  GET_OEM_HMR_WISE_REPORT:
    "/v1/simpcare/dashboard/oem/defect-code-hmr-wise-failure",

  ENGINE_PHYSICAL_STATUS: "/v1/simpcare/float-engine/sap-physical-status",
  OEM_HO_DASHBOARD_STATE_DATA: "/v1/simpcare/dashboard/oem/state-wise",
  MIS_CHART_DATA: "/v1/simpcare//dashboard/mis",
  ENGINE_MODEL_LIST: "/v1/simpcare/ticket/engine-modal",
  LIST_NUMBERS_LIST: "/v1/simpcare/ticket/list-number",
  AGEING_DATA: "/v1/simpcare/dashboard/ageing",
  OEM_AGEING_DATA: "/v1/simpcare/dashboard/oem/ageing",
  SERVICE_ENG_REPORT: "/v1/simpcare/ticket/service-engineer-report",
  HO_OEM_LIST: "/v1/simpcare/oems/ho/list-oems",
  TICKET_PAST_HISTORY: "/v1/simpcare/ticket/past-history",
  SERVICE_ENG_AGEING: "/v1/simpcare/dashboard/service-engineer-ageing",
  FLOAT_INVENTORY_STOCK_DETAILS:
    "/v1/simpcare/float-engine/dashboard/plant-oem-wise-count",
  FLOAT_INVENTORY_COST_DETAILS:
    "/v1/simpcare/float-engine/dashboard/plant-oem-wise-cost",
  STOCK_DETAILS_WRT_PLANT_AND_LIST:
    "/v1/simpcare/float-engine/dashboard/plant-list-number-wise",
  REPAIRED_AND_DEFECTIVE_STATUS: "/v1/simpcare/float-engine/dashboard/status",
  FLOAT_INVENTORY_TREND:
    "/v1/simpcare/float-engine/dashboard/float-inventory-trend",
  DAYS_TO_DISPATCH_ENGINE:
    "/v1/simpcare/float-engine/dashboard/state-wise-dispatch-report",
  STATE_WISE_DISPATCH_REPORT:
    "/v1/simpcare/work-order/state-wise-dispatch-report",
  TOP_5_DEFECT_CODE: "/v1/simpcare/dashboard/defect-code-top-five",
  DEFECT_CODE_LIST: "/v1/simpcare/dashboard/defect-code-list",
  DEFECT_CODE_BY_NAMES: "/v1/simpcare/dashboard/defect-code-by-names",
  DASHBOARD_ENGINE_REPLACEMENT_COST:
    "/v1/simpcare/dashboard/engine-replacement-trend-cost",
  DASHBOARD_PART_COST_DATA: "/v1/simpcare/dashboard/part-wise-cost",
  EXPORT_ENGINE_TRACKING: "/v1/simpcare/export-engine-tracking",
  EVENT_SCHEDULE: "/v1/simpcare/events",
  OEM_EVENT_SCHEDULE: "/v1/simpcare/events/oem",
  TRAINING_TOUCH_POINTS: "/v1/simpcare/training-touch-points",
  KNOWLEDGE_SHARING: "/v1/simpcare/knowledge-sharing",
  TRAINING_MODULE: "/v1/simpcare/training-module",
  CHECK_WARRANTY: "/v1/simpcare/engine-details/check-validity",
  CHECK_WARRANTY_ADMIN: "/v1/simpcare/engine-details/check-validity-admin",
  OFFICE_NOTE: "/v1/simpcare/office-note",
};

// export const HOSTNAME = "http://localhost:4000";
export const HOSTNAME = "https://api0-service.simpsons.in";
// export const HOSTNAME =
//   "https://sim.bellcorpstudio.com";
